import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import GreinerOfferPage from "./pages/GreinerOfferPage";
import GreinerLiptalOfferPage from "./pages/GreinerLiptalOfferPage";
import PromensOfferPage from "./pages/PromensOfferPage";
import BestDriveOfferPage from "./pages/BestDriveOfferPage";
import BestDriveFleetPage from "./pages/BestDriveFleetPage";
import SilentCzech30Page from "./pages/SilentCzech30Page";
import PSPlastyPage from "./pages/PSPlastyPage";
import ClimaxOfferPage from "./pages/ClimaxOfferPage";
import BeraniSkyboxPage from "./pages/BeraniSkyboxPage";
import BeraniOrdersAdminPage from "./pages/BeraniOrdersAdminPage";
import BeraniRequestsPage from "./pages/BeraniRequestsPage";
import BeraniRequestsAdminPage from "./pages/BeraniRequestsAdminPage";
import ZlinerOfferPage from "./pages/ZlinerOfferPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { OfferProvider } from "./context/OfferContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nabidky" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/greiner" 
            element={<GreinerOfferPage />} 
          />
          <Route 
            path="/greiner-assistec" 
            element={<GreinerOfferPage />} 
          />
          <Route 
            path="/greiner-liptal" 
            element={<GreinerLiptalOfferPage />} 
          />
          <Route 
            path="/promens" 
            element={<PromensOfferPage />} 
          />
          <Route 
            path="/bestdrive1" 
            element={<BestDriveOfferPage />} 
          />
          <Route 
            path="/bestdrive2" 
            element={<BestDriveFleetPage />} 
          />
          <Route 
            path="/silent-czech-30" 
            element={<SilentCzech30Page />} 
          />
          <Route 
            path="/ps-plasty" 
            element={<PSPlastyPage />} 
          />
          <Route 
            path="/climax" 
            element={<ClimaxOfferPage />} 
          />
          <Route 
            path="/zliner-vanoce-2026" 
            element={<ZlinerOfferPage />} 
          />
          <Route 
            path="/berani/skybox" 
            element={<BeraniSkyboxPage />} 
          />
          <Route 
            path="/berani/pozadavky" 
            element={<BeraniRequestsPage />} 
          />
          <Route 
            path="/admin/berani-orders" 
            element={
              <ProtectedRoute>
                <BeraniOrdersAdminPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/berani-requests" 
            element={
              <ProtectedRoute>
                <BeraniRequestsAdminPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nabidky/:slug" 
            element={
              <OfferProvider>
                <HomePage />
              </OfferProvider>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

